module.exports = "<section class=\"error\">\r\n    <h1>Sidan du söker kan inte hittas</h1>\r\n    <p>(404)</p>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main